import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Row, Col, Alert } from 'reactstrap';
import { createSelector } from 'reselect';
import { togglePublishScriptSuccModal } from '../../../../slices/modals/reducer';
import PrismCode from "../../../../Components/Common/Prism";
import { setPublishedCreatives, setSelectedCreativesPublish } from '../../../../slices/publish/reducer';

function PublishSuccess() {
  const dispatch = useDispatch();
  const selectModalState = createSelector(state => state.Modal, state => state.publishScriptSuccModal);
  const modalState = useSelector(selectModalState);
  
  const selectPublishedCreatives = createSelector(state => state, state => ({
    publishedCreatives: state.Publish.publishedCreatives,
    selectedCreativesPublish: state.Publish.selectedCreativesPublish,
    creatives: state.Campaign.creatives
  }));
  const {publishedCreatives, selectedCreativesPublish, creatives} = useSelector(selectPublishedCreatives);
  const [codeState, setCodeState] = useState('');

  useEffect(() => {
    if (publishedCreatives) {
      let codeString='';
      let i = 0;
      do {
        let size = selectedCreativesPublish[i]?.size;
        if (!size) {
          const foundCreative = creatives.find(creative => creative._id === publishedCreatives[i].creativeId);
          if (foundCreative) {
            size = foundCreative.size;
          }
        }
        codeString += `<!-- ${size} --> \n`;  
        codeString += publishedCreatives[i].script + '\n'; 
        i++;
      } while (i < publishedCreatives.length);
      setCodeState(codeString);
      dispatch(setSelectedCreativesPublish([]));
      
    }
  }, [publishedCreatives]);

  function closeModal() {
    dispatch(togglePublishScriptSuccModal());
    setTimeout(() => {
      dispatch(setPublishedCreatives(null));
    }, 200);
  }

  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='lg'>
      <ModalHeader className='p-3' toggle={closeModal}>
        <b>Publish Success</b>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <Alert color='success' className='alert-additional text-primary'>
              <div className='alert-body'>
                <div className='d-flex'>
                  <div className='flex-shrink-0 me-3'>
                    <i className="ri-notification-off-line fs-16 align-middle"></i>
                  </div>
                  <div className='flex-grow-1'>
                    <h5 className='alert-heading'>Your creatives published correctly</h5>
                    <p className='mb-0'>Yey! Everything worked!</p>
                  </div>
                </div>
              </div>
            </Alert>
          </Col>
        </Row>
        <Row>
          <Col>
            <PrismCode
              code={codeState}
              language={"html"}
            />
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default PublishSuccess
